<template>
  <div>
    <BaseFrame @submit='submit' submitText='提交' :submitLoading='downLoadLoading'>

      <div slot="content">
        <lk-card :title="cardTitle">
          <lk-form :label-width="160"  :model='info.ep' ref="form">
            <lk-row :gutter='16'>
              <lk-col span='11'>
                <lk-row :gutter='16'>
                  <lk-form-item label='患者姓名:'>
                    <!-- <lk-input v-if=" canUpdate" v-model="info.ep.patientName"></lk-input> -->
                    <span >{{info.ep.patientName}}</span>
                  </lk-form-item>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-form-item label='联系方式:' prop='patientPhone'>
                    <!-- <lk-input v-if="canUpdate" v-model="info.ep.patientPhone"></lk-input> -->
                    <span >{{info.ep.patientPhone}}</span>
                  </lk-form-item>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-form-item label='是否冻结药品库存:'>
                    <lk-radio-group v-model="info.frozenStatus" v-if="able">
                      <lk-radio :label='1'>冻结</lk-radio>
                      <lk-radio :label='2'>解冻</lk-radio>
                    </lk-radio-group>
                    <span v-else>{{frozenStatusStringList[info.frozenStatus]}}</span>
                  </lk-form-item>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-form-item label='备注:'>
                    <lk-input placeholder='添加备注' v-model="info.ep.remark" v-if="able"></lk-input>
                    <span v-else>{{info.ep.remark|defaultStr}}</span>
                  </lk-form-item>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-form-item label='商保支付状态:'>

                    <!-- <lk-input v-if=" canUpdate" v-model="info.ep.paymentStatusName"></lk-input> -->
                    <span >{{info.ep.paymentStatusName|defaultStr}}</span>
                  </lk-form-item>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-form-item label='支付方式:'>
                    <span >{{info.ep.proceedsType|defaultStr}}</span>
                  </lk-form-item>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-form-item label='支付金额:'>
                    <span>{{info.ep.proceedsAmount || 0}}</span>
                  </lk-form-item>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-form-item label='收货人:' prop='consigneeName'>

                    <!-- <lk-input v-if=" canUpdate" v-model="info.ep.consigneeName"></lk-input> -->
                    <span >{{info.ep.consigneeName|defaultStr}}</span>
                  </lk-form-item>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-form-item label='联系方式:' prop='consigneePhone'>

                    <!-- <lk-input v-if=" canUpdate" v-model="info.ep.consigneePhone"></lk-input> -->
                    <span >{{info.ep.consigneePhone|defaultStr}}</span>
                  </lk-form-item>
                </lk-row>
                 <lk-row :gutter='16'>
                  <lk-form-item label='配送方式:'>

                    <!-- <lk-input v-if=" canUpdate" v-model="info.ep.consigneePhone"></lk-input> -->
                    <span >{{deliveryMethodTypes[info.ep.deliveryMethod]|defaultStr}}</span>
                  </lk-form-item>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-form-item label='收货地址:' prop='consigneeAddress'>

                    <!-- <lk-input v-if=" canUpdate" v-model="info.ep.consigneeAddress"></lk-input> -->
                    <span >{{info.ep.consigneeAddress|defaultStr}}</span>
                  </lk-form-item>
                </lk-row>
                <lk-row :gutter='16' v-if='info.ep.type===5 || info.ep.type===6'>
                  <lk-form-item label='期望送达时间:' prop='consigneeAddress'>
                    <span >{{info.ep.expectedDeliveryTime|defaultStr}}</span>
                  </lk-form-item>
                </lk-row>
                  <lk-row :gutter='16'>
                    <lk-form-item label='三方订单号:'  prop='onlineOrderCode'>

                    <!-- <lk-input v-if=" canUpdate" v-model="info.ep.onlineOrderCode"></lk-input> -->
                      <span>{{info.ep.onlineOrderCode|defaultStr}}</span>
                    </lk-form-item>
                  </lk-row>
                  <lk-row :gutter='16'>
                    <lk-form-item label='小程序订单号:'>

                    <!-- <lk-input v-if=" canUpdate" v-model="info.ep.wechatPayCode"></lk-input> -->
                      <span >{{info.ep.appletOrderCode|defaultStr}}</span>
                    </lk-form-item>
                  </lk-row>
                  <lk-row :gutter='16'>
                    <lk-form-item label='联系人:'>
                      <span >{{info.ep.contact|defaultStr}}</span>
                    </lk-form-item>
                  </lk-row>
                <lk-row :gutter='16'>
                  <lk-table :columns='columns' :data=info.epDetailVoList border></lk-table>
                </lk-row>
                <img :src="src" alt="">
              </lk-col>
              <lk-col span='11' offset='1' v-if="isPrescrption && currentImg">
                <div class="prescriptionContainer" >
                  <div class="printContainer" id="pic">
                    <img ref="pic" class='stamp' :src="currentImg" alt="">
                    <lk-Page :current="pageData.current" :page-size="1" :total="pageData.total" v-if="currentImg" simple @on-change="changePage"  class="image-page"/>
                  </div>
                </div>
                <div class="btnContainer">
                  <lk-button @click="downLoadPDF" type='primary' :loading='downLoadLoading'>下载
                  </lk-button>
                </div>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </BaseFrame>
  </div>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';
import sale from '../../services/sale';
import utils from '../../libs/utils';

export default {
  name: 'prescriptionInfo',
  components: {
    BaseFrame,
  },
  computed: {
    cardTitle() {
      return `${this.$route.meta.parentTitle}信息`
    },
    isPrescrption() {
      return this.$route.name && this.$route.name.includes('prescription');
    },
  },
  data() {
    return {
      able: false,
      src: '',
      downLoadLoading: false,
      frozenStatusStringList: {
        1: '冻结',
        2: '解冻',
      },
      currentImg: '',
      currentList: [],
      deliveryMethodTypes: {
        2: '门店自提',
        3: '门店配送',
      },
      info: {
        ep: {},
        epDetailList: [],
        epProceedsList: [{
          proceedsTypeName: null,
          amount: null,
        }],
      },
      pageData: {
        current: 1,
        total: 5,
      },
      columns: [{
        title: '序号',
        type: 'index',
      },
      {
        title: '商品编码',
        key: 'serialCode',
      },
      {
        title: '商品通用名',
        key: 'approvedDrugNames',
      },
      {
        title: '商品名',
        key: 'goodsName',
      },
      {
        title: '规格',
        key: 'spec',
      },
      {
        title: '数量',
        key: 'epDetailNum',
      },
      ],
    };
  },
  methods: {
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const temp = {

            id: this.info.ep.id,
            remark: this.info.ep.remark,
            frozenStatus: this.info.frozenStatus,
            patientName: this.info.ep.patientName,
            patientPhone: this.info.ep.patientPhone,
            consigneeName: this.info.ep.consigneeName,
            consigneePhone: this.info.ep.consigneePhone,
            consigneeAddress: this.info.ep.consigneeAddress,
            onlineOrderCode: this.info.ep.onlineOrderCode,

          };
          sale.prescriptionEdit(temp).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('提交成功');
              this.$router.push({
                name: 'prescriptionList',
              });
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        }
      });
    },
    getBase64Image() {
      // const img = this.$refs.pic;
      // const el=img
      const img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');
      img.src = this.$refs.pic.url;

      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, img.width, img.height);


      const dataURL = canvas.toDataURL('image/png', 1);
      return dataURL;

      // return dataURL.replace("data:image/png;base64,", "");
    },
    downLoadPDF() {
      const el = this.$refs.pic;
      window.open(el.src);
    },
    changePage(e) {
      this.currentImg = this.currentList[e - 1];
    },
    getData(epId) {
      sale.getPrescriptiondDetail({
        epId,
      }).then((res) => {
        if (res.data.status === 200) {
          this.info = res.data.data;
          const picUrls = this.info.ep.picUrls ? this.info.ep.picUrls : [];
          if (picUrls.length >0) {
            this.currentImg = picUrls.length >0 ? decodeURIComponent(picUrls[0]) : '';
            const imgList = [];
            this.info.ep.picUrls.forEach((item) => {
              imgList.push(decodeURIComponent(item));
            });
            this.currentList = imgList;
            this.pageData.total = imgList.length;
          }
          this.info.epDetailVoList = this.info.epDetailVoList.map((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            return result;
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.$route.name.includes('Edit') && (this.able = true);

    this.getData(this.$route.params.id);
  },
};

</script>
<style lang="less" scoped>
  .btnContainer {
    text-align: center;
    margin-top:20px;
  }

  .printContainer {
    overflow: scroll;
    padding: 5px 0;
    border: 1px solid #eee;

    .stamp {
      width: 100%
    }
  }
  .image-page {
    margin: 10px 0;
    display: flex;
    justify-content: center;
  }

</style>
